<template>
  <div>
    <loadingCube v-if="!loading_company" :loadingMessage="'COMPANY'"></loadingCube>
    <div v-else class="company_record_info">

      <div class="r_info">
        <div class="row">
          <div class="col-12">
            <h2 class="font-weight-bold bp_color mb-0">{{ company.company_name }}</h2>
            <h4 v-if="company.rel_profile.ltd_reg_number !== null" class="mb-0">{{ company.rel_profile.ltd_reg_number }} &nbsp; <i class="fas fa-edit edit_reg_no_btn"
                                                                                                                                   @click="edit_reg_number_modal"></i></h4>
            <button class="btn orcaBtn sm_btn mb-2 mt-2 warning" @click="add_reg_number_modal" v-else><i class="fas fa-edit"></i> &nbsp; Missing Reg Number</button>
          </div>
          <div class="col-lg-3">
            <div class="info">
              <p class="b3_color mb-0"><strong>Type:</strong> {{ company.company_type }}</p>
              <p class="b3_color mb-0"><strong>Ref:</strong> {{ company.internal_finance_ref }}</p>
              <p class="b3_color mb-0" v-if="company.primary_consultant_id !== null"><strong><i class="fas fa-user-tie"></i></strong> {{ company.primary_consultant.first_name }}
                                                                                                                                      {{ company.primary_consultant.surname }}</p>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="info contact">
              <div v-if="company.rel_profile.office_phone"><strong><i class="fas fa-phone-alt"></i></strong>{{ company.rel_profile.office_phone.phone_number }}</div>
              <div v-if="company.rel_profile.office_email"><strong><i class="fas fa-at"></i></strong>
                <a :href="'mailto:' + company.rel_profile.office_email.email_address" class="email_link">{{ company.rel_profile.office_email.email_address }}</a></div>
              <div v-if="company.rel_profile.office_website !== null"><strong><i class="fas fa-desktop"></i></strong>
                <a :href="'http://' + company.rel_profile.office_website" class="email_link">{{ company.rel_profile.office_website }}</a></div>
            </div>
          </div>
          <div class="col-lg-6 info additional_info">
              <p class="b3_color mb-0"><strong>UTR Status:</strong> {{ company.rel_profile.utr_status }}</p>
              <p class="b3_color mb-0" v-if="payment_process_info.payroll_trading_company_id !== null"><strong>GM Company:</strong>
                {{ $store.state.crm_options.payroll_trading_company.find(tc => tc.id === payment_process_info.payroll_trading_company_id)?.value }}
              </p>
              <p class="b3_color mb-0" v-if="payment_process_info.payroll_solution_id !== null"><strong>Payroll Solution:</strong>
                {{ $store.state.crm_options.payroll_client_solution.find(p => p.id === payment_process_info.payroll_solution_id)?.value }}
              </p>

              <p class="b3_color mb-0" id="payroll_company_name"
                 v-if="company.rel_profile.payroll_company_name !== null">
                  <strong>
                      Payroll Company:
                  </strong>
                  <span>{{ company.rel_profile.payroll_company_name }}</span>
              </p>
              <p class="b3_color mb-0" id="payroll_company_charge_amount"><strong>
                  Charge Amount
              </strong>
                  <span v-if="company.rel_profile.payroll_company_charge_type !== null">
                     <span>{{ company.rel_profile.payroll_company_charge_type }}</span>
                     <span v-if="company.rel_profile.payroll_company_charge_type === '£ (Pound)'">
                       {{ charge_amount | currency }}
                     </span>
                     <span v-else-if="company.rel_profile.payroll_company_charge_type === '% (Percentage)'">
                       {{ charge_amount | percentage }}
                     </span>
                     <span v-else>
                         {{ charge_amount }}
                     </span>
                   </span>
                  <span v-else>&nbsp;</span>
              </p>
          </div>
          <!-- V3 CLIENT on payroll crm -->
          <div class="col-12 mt-3">
            <div id="payroll_recruitment_client" v-if="crmType === 'payroll' && company.payroll_recruitment_client">
              V3 CLIENT
            </div>
            <!-- BAROMETER -->
            <b-progress max="100" height="40px" class="company_barometer mb-3">
              <b-progress-bar variant="primary" value="10"></b-progress-bar>
              <b-progress-bar variant="warning" value="20"></b-progress-bar>
              <b-progress-bar variant="success" value="40"></b-progress-bar>
            </b-progress>
          </div>
        </div>
      </div>
      <div class="r_quick_buttons">
        <div class="q_btn">
          <button @click="delete_company_record" class="btn orcaBtn danger delete_btn sm_btn mb-2" data-toggle="tooltip"
                  style="min-width: 45px;"
                  title="Delete Client Record" v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager'))"
                  @mouseover="delete_company_hover = true" @mouseleave="delete_company_hover = false">
            <i class="fas fa-trash-alt"></i><span v-if="delete_company_hover"> &nbsp; Delete Company</span>
          </button>
        </div>
        <div class="q_btn">
          <button @click="add_address_modal" class="btn orcaBtn sm_btn mb-2" data-toggle="tooltip" title="Add Address to Client"
                  style="min-width: 45px;"
                  @mouseover="add_address_hover = true" @mouseleave="add_address_hover = false">
            <i class="fas fa-map-marker-alt"></i><span v-if="add_address_hover"> &nbsp; Add Address</span>
          </button>
        </div>
        <div class="q_btn">
          <button @click="add_contact_modal" class="btn orcaBtn sm_btn mb-2" data-toggle="tooltip" title="Add Contact to Client"
                  style="min-width: 45px;"
                  @mouseover="add_contact_hover = true" @mouseleave="add_contact_hover = false">
            <i class="fas fa-user-plus"></i><span v-if="add_contact_hover"> &nbsp; Add Contact</span>
          </button>
        </div>
        <div class="q_btn">
          <button @click="add_note_modal" class="btn orcaBtn sm_btn mb-2" data-toggle="tooltip" title="Add Note to Client/Contact"
                  style="min-width: 45px;"
                  @mouseover="add_note_hover = true" @mouseleave="add_note_hover = false">
            <i class="fas fa-comment-dots"></i><span v-if="add_note_hover"> &nbsp; Add Note</span>
          </button>
        </div>
        <div class="q_btn">
          <button @click="add_files_modal" class="btn orcaBtn sm_btn mb-2" data-toggle="tooltip" title="Add Document to Client/Contact"
                  style="min-width: 45px;"
                  @mouseover="add_document_hover = true" @mouseleave="add_document_hover = false">
            <i class="fas fa-file-upload"></i><span v-if="add_document_hover"> &nbsp; Add Document</span>
          </button>
        </div>
      </div>

      <!--        <div class="col-12">-->
      <!--          <div class="record_short_btns">-->
      <!--            <div class="row">-->
      <!--              <div class="col-md-5 text-left">-->
      <!--                <button @click="createEmail" class="btn orcaBtn sm_btn mb-2 mr-1 ml-1 disabled" disabled data-toggle="tooltip" title="Send Email">-->
      <!--                  <i class="fas fa-paper-plane"></i> &nbsp; Email-->
      <!--                </button>-->
      <!--                <button @click="createEvent" class="btn orcaBtn sm_btn mb-2 mr-1 ml-1 disabled" disabled data-toggle="tooltip" title="Create Event">-->
      <!--                  <i class="fas fa-calendar-plus"></i> &nbsp; Event-->
      <!--                </button>-->
      <!--                <button @click="createTask" class="btn orcaBtn sm_btn mb-2 mr-1 ml-1 disabled" disabled data-toggle="tooltip" title="Create Task">-->
      <!--                  <i class="fas fa-plus-square"></i>&nbsp; Task-->
      <!--                </button>-->
      <!--              </div>-->

      <b-tabs v-model="company_record_tabIndex" pills vertical>
        <b-tab title="Dashboard & Notes" lazy>
          <b-card-text>
            <dashboard v-if="notEmptyObject(company)" :company="company" :notes="notes" :phones="phones" :emails="emails" :services="services"></dashboard>
          </b-card-text>
        </b-tab>
        <b-tab title="Company Information" lazy>
          <b-card-text>
            <company_info v-if="notEmptyObject(company)" :company="company"></company_info>
          </b-card-text>
        </b-tab>
        <b-tab title="CIS Verification" lazy>
          <b-card-text>
            <company_cis_verification :company="company" :cis_status="cis_status" :cis_loaded="cis_loaded"></company_cis_verification>
          </b-card-text>
        </b-tab>
        <b-tab title="Addresses & Contacts" lazy>
          <b-card-text>
            <addresses_contacts :addresses="addresses" :contacts="contacts"></addresses_contacts>
          </b-card-text>
        </b-tab>
        <b-tab title="Compliance" lazy>
          <b-card-text>
            <compliance :company="company" :health_check="health_check" :service_company_reports="service_company_reports"></compliance>
          </b-card-text>
        </b-tab>
        <b-tab title="Accounts & Payment" lazy>
          <b-card-text>
            <accounts_payment v-if="notEmptyObject(company)" :company="company" :payment_process_info="payment_process_info"
                              :referral_rebate="referral_rebate" :credit_finance="credit_finance"></accounts_payment>
          </b-card-text>
        </b-tab>
        <b-tab title="Contracts & Orders" lazy>
          <b-card-text>
            <contracts_orders :contracts="contracts" :default_timesheet_auth="default_timesheet_auth" :company="company" :payment_process_info="payment_process_info"
                              :addresses="addresses" :contacts="contacts" :orders="orders"></contracts_orders>
          </b-card-text>
        </b-tab>
        <b-tab title="Timesheet Auth & Login" lazy>
          <b-card-text>
            <timesheet_auth_logins :default_timesheet_auth="default_timesheet_auth" :default_timesheet_auth_loaded="default_timesheet_auth_loaded"
                                   :contacts="contacts" :company="company"></timesheet_auth_logins>
          </b-card-text>
        </b-tab>
        <b-tab title="Assignments" lazy disabled>
          <b-card-text>
            <!--              <assignments v-if="notEmptyObject(company)" :current_assignments="current_assignments" :historic_assignments="historic_assignments"></assignments>-->
          </b-card-text>
        </b-tab>
        <!--                <b-tab title="Timesheets" lazy :title-link-class="check_signed_contract_class" :disabled="check_signed_contract" disabled>-->
        <b-tab title="Timesheets" lazy >
          <b-card-text>
            <admin_timesheet_select_period :company_id="company.id"/>
          </b-card-text>
        </b-tab>
        <b-tab title="Events & Tasks" lazy disabled>
          <b-card-text>
            <!--              <events_tasks></events_tasks>-->
          </b-card-text>
        </b-tab>
        <b-tab title="Communication" lazy disabled>
          <b-card-text>
            <!--              <emails></emails>-->
          </b-card-text>
        </b-tab>
        <b-tab title="Documents" lazy>
          <b-card-text>
            <documents v-if="notEmptyObject(company)" :files="files" :filesLoaded="files_loaded"></documents>
          </b-card-text>
        </b-tab>
        <b-tab title="Activity on Record" lazy v-if="canViewLogs()">
          <b-card-text>
            <logs :logs="activity" :logsLoaded="activity_loaded"></logs>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>

    <modal_add_reg_number v-if="$store.state.companies.reg_modal.add_modal"></modal_add_reg_number>
    <modal_edit_reg_number v-if="$store.state.companies.reg_modal.edit_modal"></modal_edit_reg_number>
  </div>
</template>

<script>
import loadingCube from "loaders/record_loader";
import Dashboard from "pages/companies/record/dashboard";
import company_info from "pages/companies/record/company_info";
import company_cis_verification from "pages/companies/record/cis_verification"
import Addresses_contacts from "pages/companies/record/addresses_contacts";
import compliance from "pages/companies/record/compliance";
import Accounts_payment from "pages/companies/record/accounts_payment";
import Contracts_orders from "pages/companies/record/contracts_orders";
import timesheet_auth_logins from "pages/companies/record/timesheet_auth_logins"
import assignments from "pages/companies/record/assignments"
import timesheets from "pages/companies/record/timesheets"
import events_tasks from "pages/companies/record/events_tasks";
import emails from "pages/companies/record/emails";
import Documents from "pages/companies/record/documents";
import logs from "pages/companies/record/logs"
import modal_add_reg_number from "components/partials/modals/companies/add_reg_number_modal"
import modal_edit_reg_number from "components/partials/modals/companies/edit_reg_number_modal"
import Admin_timesheet_select_period from "pages/sunset/timesheets/admin/timesheet_select_period.vue";

export default {
  name: "company_record",
  components: {
    Admin_timesheet_select_period,
    Dashboard,
    company_info,
    company_cis_verification,
    Addresses_contacts,
    compliance,
    Accounts_payment,
    Contracts_orders,
    timesheet_auth_logins,
    assignments,
    timesheets,
    events_tasks,
    emails,
    Documents,
    logs,
    loadingCube,
    modal_add_reg_number,
    modal_edit_reg_number
  },
  data() {
    return {
      company_record_tabIndex: this.$store.state.companies.current_record_tab_index,

      // current signed in crm user details
      user: this.$store.state.auth.me,

      loading_company: false,
      company_id: null,
      company: {},

      delete_company_hover: false,
      add_note_hover: false,
      add_document_hover: false,
      add_contact_hover: false,
      add_address_hover: false,

      cis_status: {},
      cis_loaded: false,

      addresses_loaded: false,
      addresses: [],
      emails_loaded: false,
      emails: [],
      phones_loaded: false,
      phones: [],
      banks_loaded: false,
      banks: [],
      credit_finance_loaded: false,
      credit_finance: [],
      payment_process_info_loaded: false,
      payment_process_info: [],
      referral_rebate_loaded: false,
      referral_rebate: [],
      relationship_loaded: false,
      relationship: [],
      services_loaded: false,
      services: [],
      contracts_loaded: false,
      contracts: [],
      health_check_loaded: false,
      health_check: {},
      service_compliance_reports_loaded: false,
      service_company_reports: [],
      sent_health_check_loaded: false,
      sent_health_check: [],

      contacts_loaded: false,
      contacts: [],

      notes_loaded: false,
      notes: [],
      activity_loaded: false,
      activity: [],

      orders_loaded: false,
      orders: [],

      default_timesheet_auth_loaded: false,
      default_timesheet_auth: {},

      files_loaded: false,
      files: {},
      files_uploaded: [],
      file_order: ['contract'],
    }
  },
  computed: {
    file_reload() {
      return this.$store.state.files.reload_files;
    },
    /**
     * TAB CHECKS ----------------------------------------------------------
     */
    // check_pre_agreement() {
    //   if (this.notEmptyObject(this.pre_agreement) && this.notEmptyObject(this.payment_process_info)) {
    //     return !(this.check_utr_and_payment_process_info_null_values() && this.check_payment_process_info_fee_margin_agreed()
    //         && this.check_pre_agreement_recruitment_partnership());
    //   }
    //   else {
    //     return true
    //   }
    // },
    // check_pre_agreement_class() {
    //   if (this.notEmptyObject(this.pre_agreement) && this.notEmptyObject(this.payment_process_info)) {
    //     if (this.check_utr_and_payment_process_info_null_values() && this.check_payment_process_info_fee_margin_agreed()
    //         && this.check_pre_agreement_recruitment_partnership()) {
    //       return ''
    //     }
    //     else {
    //       return 'tab_unavailable'
    //     }
    //   }
    //   else {
    //     return 'tab_unavailable'
    //   }
    // },

    check_signed_contract() {
      if (this.notEmptyObject(this.contracts)) {
        return !this.check_contract_is_signed();
      }
      else {
        return true;
      }
    },
    check_signed_contract_class() {
      if (this.notEmptyObject(this.contracts)) {
        if (this.check_contract_is_signed()) {
          return '';
        }
        else {
          return 'tab_unavailable'
        }
      }
      else {
        return 'tab_unavailable'
      }
    },

    /**
     * RELOADS ----------------------------------------------------------
     */
    company_reload() {
      return this.$store.state.companies.reload_company;
    },
    charge_amount() {
      let amount = this.company.rel_payment_process_info.fee_margin_amount;
      amount += process.env.MIX_PE_INS;

      return amount;
    },
    address_reload() {
      return this.$store.state.addresses.reload_addresses;
    },
    phone_reload() {
      return this.$store.state.contact_info.reload_phones;
    },
    email_reload() {
      return this.$store.state.contact_info.reload_emails;
    },
    note_reload() {
      return this.$store.state.notes.reload_notes;
    },
    file_reload() {
      return this.$store.state.files.reload_files;
    },
    activity_reload() {
      return this.$store.state.logs.reload_logs;
    },

    contact_reload() {
      return this.$store.state.contacts.reload_contacts;
    },

    bank_reload() {},
    contracts_reload() {
      return this.$store.state.companies.reload_contracts;
    },
    credit_finance_reload() {
      return this.$store.state.company_credit_finance.reload_company_credit_finance;
    },
    service_compliance_reports_reload() {
      return this.$store.state.company_health_check.reload_service_company_reports;
    },
    health_check_reload() {
      return this.$store.state.company_health_check.reload_company_health_check;
    },
    payment_process_info_reload() {
      return this.$store.state.company_payment_process_info.reload_company_payment_process_info;
    },
    // pre_agreement_reload() {
    //   return this.$store.state.company_pre_agreement.reload_company_pre_agreement;
    // },
    referrals_reload() {
      return this.$store.state.company_referrals.reload_company_referrals;
    },
    services_reload() {
      return this.$store.state.company_services.reload_company_services;
    },

    default_ts_auth_reload() {
      return this.$store.state.timesheets.reload_default_client_ts_auth;
    },
    assignment_reload() {
      return this.$store.state.assignments.reload_assignments;
    },
    cis_reload() {
      return this.$store.state.companies.reload_cis;
    },
  },
  beforeMount() {
    this.company_id = this.$store.state.companies.current_record_company_id;
    
    if(this.$route.query.company_id){
      this.company_id = this.$route.query.company_id;
    }
    
    this.get_company_data();
    this.get_company_files();
  },
  watch: {
    company_record_tabIndex(tab) {
      this.$store.commit('SET_COMPANY_TAB_INDEX', tab);
    },
    /**
     * RELOADS ----------------------------------------------------------
     */
    cis_reload(val) {
      if (val) {
        this.cis_loaded = false;
        this.get_cis_status();
      }
    },
    company_reload(val) {
      if (val) {
        this.loading_company = false;
        this.get_company_data().then(() => this.loading_company = true);
      }
    },
    address_reload(val) {
      if (val) {
        this.addresses_loaded = false;
        this.get_company_addresses();
      }
    },
    phone_reload(val) {
      if (val) {
        this.phones_loaded = false;
        this.get_company_phones();
      }
    },
    email_reload(val) {
      if (val) {
        this.emails_loaded = false;
        this.get_company_emails();
      }
    },
    note_reload(val) {
      if (val) {
        this.notes_loaded = false;
        this.get_company_notes()
      }
    },
    file_reload(val) {
      // console.log(val + ' : file reload')
      if (val) {
        this.files_loaded = false;
        this.files_uploaded = [];
        this.get_company_files()
      }
    },
    activity_reload(val) {
      if (val) {
        this.activity_loaded = false;
        this.get_company_logs()
      }
    },

    contact_reload(val) {
      if (val) {
        this.contacts_loaded = false;
        this.get_company_contacts()
      }
    },

    contracts_reload(val) {
      if (val) {
        this.contacts_loaded = false;
        this.get_company_contracts();
      }
    },
    credit_finance_reload(val) {
      if (val) {
        this.credit_finance_loaded = false;
        this.get_company_credit_finance();
      }
    },
    health_check_reload(val) {
      if (val) {
        this.health_check_loaded = false;
        this.get_company_health_check();
      }
    },
    service_compliance_reports_reload(val) {
      if (val) {
        this.service_compliance_reports_loaded = false;
        this.get_company_service_compliance_reports();
      }
    },
    payment_process_info_reload(val) {
      if (val) {
        this.payment_process_info_loaded = false;
        this.get_company_payment_process_info();
      }
    },
    // pre_agreement_reload(val) {
    //   if (val) {
    //     this.pre_agreement_loaded = false;
    //     this.get_company_pre_agreement();
    //   }
    // },
    referrals_reload(val) {
      if (val) {
        this.referrals_loaded = false;
        this.get_company_referral_rebate();
      }
    },
    services_reload(val) {
      if (val) {
        this.services_loaded = false;
        this.get_company_services();
      }
    },

    default_ts_auth_reload(val) {
      if (val) {
        this.default_timesheet_auth_loaded = false;
        this.get_company_default_ts_auth();
      }
    },
    assignment_reload(val) {
      if (val) {
        this.get_current_assignments();
        this.get_historic_assignments();
      }
    },
  },
  methods: {
    canViewLogs(){
      return this.$store.state.auth.me.permissions.includes('sunset_note_stats_restricted');
    },
    /**
     * CHECK PRE AGREEMENT INFO COMPLETE ----------------------------------------------------------
     */
    check_utr_and_payment_process_info_null_values() {
      // TODO -- && this.accounts_info.pay_period_day !== null
      // this.company.rel_profile.utr_number !== null &&
      return this.company.rel_profile.utr_status !== null
          && this.payment_process_info.pay_cycle !== null
          && this.payment_process_info.pay_week_end_day !== null
          && this.payment_process_info.pay_instruction_day !== null
          && this.payment_process_info.pay_client_payment_day !== null
          && this.payment_process_info.pay_worker_payment_day !== null
          && this.payment_process_info.pay_worker_payment_time !== null
          && this.payment_process_info.pay_worker_text_day !== null
          && this.payment_process_info.payroll_solution_id !== null
          && this.payment_process_info.min_vat_percentage_worked_to !== null;
    },
    check_payment_process_info_fee_margin_agreed() {
      if (this.payment_process_info.fee_margin_agreed) {
        return this.payment_process_info.fee_margin_type !== null && this.payment_process_info.fee_margin_amount !== null;
      }
      else {
        return false
      }
    },
    // check_pre_agreement_payroll_payment_terms() {
    // if (this.payment_process_info.payroll_require_payment_terms === false) {
    //   return true
    // }
    // else {
    //   return this.payment_process_info.payroll_payment_terms_length !== null && this.payment_process_info.payroll_payment_terms_type !== null &&
    //       this.payment_process_info.payroll_payment_terms_value !== null;
    // }
    // },
    // check_pre_agreement_recruitment_partnership() {
    //   if (this.payment_process_info.recruitment_partnership === false) {
    //     return true
    //   }
    //   else {
    //     return this.payment_process_info.recruitment_partnership_fee_type !== null && this.payment_process_info.recruitment_partnership_fee_value !== null;
    //   }
    // },
    /**
     * CHECK CONTRACT SIGNED ----------------------------------------------------------
     */
    check_contract_is_signed() {
      let is_signed = false;
      for (let i = 0; i < this.contracts.length; i++) {
        if (this.contracts[i].is_signed === true) {
          is_signed = true;
        }
      }
      return is_signed;
    },
    /**
     * GETTING COMPANY INFORMATION ----------------------------------------------------------
     */
    get_company_data() {
      return new Promise((complete) => {
        axios.get(this.crmApiPath + 'company/' + this.company_id).then(company => {
          this.company = company.data;

          // Always settle so one failed section request can't leave the page loading forever
          let failed_sections = [];
          const settle = fn => Promise.resolve().then(fn).catch(error => {
            console.error(error);
            failed_sections.push(error);
          });

          let company_promises = [];
          company_promises.push(settle(() => this.get_cis_status()));
          company_promises.push(settle(() => this.get_company_addresses()));
          company_promises.push(settle(() => this.get_company_emails()));
          company_promises.push(settle(() => this.get_company_phones()));
          company_promises.push(settle(() => this.get_company_banks()));
          company_promises.push(settle(() => this.get_company_credit_finance()));
          company_promises.push(settle(() => this.get_company_payment_process_info()));
          company_promises.push(settle(() => this.get_company_referral_rebate()));
          company_promises.push(settle(() => this.get_company_relationships()));
          company_promises.push(settle(() => this.get_company_services()));
          company_promises.push(settle(() => this.get_company_contracts()));
          company_promises.push(settle(() => this.get_company_health_check()));
          company_promises.push(settle(() => this.get_company_service_compliance_reports()));
          // company_promises.push(settle(() => this.get_company_sent_health_checks()));
          // company_promises.push(settle(() => this.get_company_pre_agreement()));
          // company_promises.push(settle(() => this.get_company_sent_pre_agreements()));
          company_promises.push(settle(() => this.get_company_contacts()));
          company_promises.push(settle(() => this.get_company_notes()));

          if(this.canViewLogs()){
            company_promises.push(settle(() => this.get_company_logs()));
          }
          company_promises.push(settle(() => this.get_company_default_ts_auth()));
          company_promises.push(settle(() => this.get_company_orders()));

          Promise.all(company_promises).then(() => {
            if (failed_sections.length) {
              this.$snotify.warning('Some company information could not be loaded.');
            }
            this.loading_company = true;
            complete();
          });
        }).catch(() => {
          this.$snotify.error('Unable to load company profile.');
          complete();
        });
      });
    },
    // Related company data
    get_cis_status() {
      let utr_number = null, trading_name = null, crn = null;
      utr_number = this.company.rel_profile.utr_number;
      crn = this.company.rel_profile.ltd_reg_number;
      trading_name = this.company.company_name;
      return axios.get(this.crmApiPath + 'hmrc/cis/status/company/info/' + this.company.id, {
        params: {
          utr_number: utr_number,
          employment_type_id: 32,
          trading_name: trading_name,
          crn: crn
        }
      }).then(res => {
          this.cis_status = res.data;
          this.cis_loaded = true;
      })
    },
    get_company_addresses() {
      return axios.get(this.crmApiPath + 'contact_info/address/company/' + this.company_id).then(addresses => {
        this.addresses = addresses.data;
        this.addresses_loaded = true;
      });
    },
    get_company_emails() {
      return axios.get(this.crmApiPath + 'contact_info/email/company/' + this.company_id).then(emails => {
        this.emails = emails.data;
        this.emails_loaded = true;
      });
    },
    get_company_phones() {
      return axios.get(this.crmApiPath + 'contact_info/phone/company/' + this.company_id).then(phones => {
        this.phones = phones.data;
        this.phones_loaded = true;
      });
    },
    get_company_banks() {
      return axios.get(this.crmApiPath + 'company/bank/company/' + this.company_id).then(banks => {
        this.banks = banks.data;
        this.banks_loaded = true;
      });
    },
    get_company_credit_finance() {
      return axios.get(this.crmApiPath + 'company/credit_finance/company/' + this.company_id).then(credit_finance => {
        this.credit_finance = credit_finance.data;
        this.credit_finance_loaded = true;
      });
    },
    get_company_payment_process_info() {
      return axios.get(this.crmApiPath + 'company/payment_process_info/company/' + this.company_id).then(payment_process_info => {
        this.payment_process_info = payment_process_info.data;
        this.payment_process_info_loaded = true;
      });
    },
    get_company_referral_rebate() {
      return axios.get(this.crmApiPath + 'company/referral_rebate/company/' + this.company_id).then(referral_rebate => {
        this.referral_rebate = referral_rebate.data;
        this.referral_rebate_loaded = true;
      });
    },
    get_company_relationships() {
      return axios.get(this.crmApiPath + 'company/relationship/company/' + this.company_id).then(relationship => {
        this.relationship = relationship.data;
        this.relationship_loaded = true;
      });
    },
    get_company_services() {
      return axios.get(this.crmApiPath + 'company/services/company/' + this.company_id).then(services => {
        this.services = services.data;
        this.services_loaded = true;
      });
    },
    get_company_contracts() {
      return axios.get(this.crmApiPath + 'company/contract/company/' + this.company_id).then(contracts => {
        this.contracts = contracts.data;
        this.contracts_loaded = true;
      })
    },
    get_company_health_check() {
      return axios.get(this.crmApiPath + 'company/health_check/company/' + this.company_id).then(health_check => {
        if (health_check.data !== '') {
          this.health_check = health_check.data;
        }
        this.health_check_loaded = true;
      });
    },
    get_company_service_compliance_reports() {
      return axios.get(this.crmApiPath + 'company/service_compliance_report/company/' + this.company_id)
                  .then(service_reports => {
                    if (service_reports.data !== '') {
                      this.service_company_reports = service_reports.data;
                    }
                    this.service_compliance_reports_loaded = true;
                  });
    },
    get_company_sent_health_checks() {
      return axios.get(this.crmApiPath + 'company/sent_health_check/company/' + this.company_id).then(sent_health_check => {
        this.sent_health_check = sent_health_check.data;
        this.sent_health_check_loaded = true;
      });
    },
    // get_company_pre_agreement() {
    //   return axios.get(this.crmApiPath + 'company/pre_agreement/company/' + this.company_id).then(pre_agreement => {
    //     this.pre_agreement = pre_agreement.data;
    //     this.pre_agreement_loaded = true;
    //   });
    // },
    // get_company_sent_pre_agreements() {
    //   return axios.get(this.crmApiPath + 'company/sent_pre_agreement/company/' + this.company_id).then(sent_pre_agreement => {
    //     this.sent_pre_agreement = sent_pre_agreement.data;
    //     this.sent_pre_agreement_loaded = true;
    //   });
    // },
    get_company_contacts() {
      return axios.get(this.crmApiPath + 'contact/company/' + this.company_id).then(contacts => {
        this.contacts = contacts.data;
        this.contacts_loaded = true;
      })
    },
    get_company_notes() {
      return axios.get(this.crmApiPath + 'sunset/notes/company/' + this.company_id).then(notes => {
        this.notes = notes.data;
        this.notes_loaded = true;
      })
    },

    get_company_logs() {
      return axios.get(this.crmApiPath + 'sunset/logs/company/' + this.company_id).then(activity => {
        this.activity = activity.data;
        this.activity_loaded = true;
      })
    },

    get_company_orders() {
      return axios.get(this.crmApiPath + 'sunset/order-jobs/company/' + this.company_id).then(client_orders => {
        this.orders = client_orders.data;
      });
    },
    get_company_default_ts_auth() {
      return axios.get(this.crmApiPath + 'timesheet_authorisation/client/get/' + this.company_id + '?require_user=false').then(ts_auth => {
        this.default_timesheet_auth = ts_auth.data;
        this.default_timesheet_auth_loaded = true;
      })
    },
    get_company_files() {
      return axios.get(this.crmApiPath + 'file/company/' + this.company_id).then(company_files => {
        this.files = this.mapArrayOrder(company_files.data, this.file_order, 'type');

        this.files.sort(function (a, b) {
          let file_a = a.type.file_type.toLowerCase(), file_b = b.type.file_type.toLowerCase();
          if (file_a < file_b) {
            return -1
          }
          if (file_a > file_b) {
            return 1
          }
        });

        this.files_loaded = true;
        this.$nextTick(() => company_files.data.forEach(file => this.files_uploaded.push(file.type.id)));
      });
    },
    /**
     * Office365 ----------------------------------------------------------
     */
    createEmail() {
      this.$router.push('/email/create');
    },
    createEvent() {
      this.$router.push('/calendar/event/create');
    },
    createTask() {
      this.$router.push('/tasks/create');
    },
    /**
     * Client Functions ----------------------------------------------------------
     */
    edit_company_record() {},
    delete_company_record() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: 
            '<div class="snotifyToast__title">Confirm Delete Company</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you wish to delete:<br>' +
            `<strong>${this.company.company_name}</strong>` +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '<div style="margin-top:10px;">' +
            '<label for="deleteReason">Please provide a reason:</label><br>' +
            '<textarea id="deleteReason" style="width:100%; height:70px; margin-top:5px;" placeholder="Enter reason..."></textarea>' +
            '</div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {

              const reason = document.getElementById('deleteReason').value.trim();
              
              if (!reason) {
                alert('Please provide a reason before deleting.');
                return;
              }

              this.$store.commit('SET_DELETE_COMPANY_ID', this.company.id);
              this.$snotify.remove(toast.id);
              axios.delete(this.crmApiPath + 'company/' + this.company.id, {
                params: {
                  // Set log values (current crm user)
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id,
                  deleted_reason: reason
                }
              }).then(() => {
                  this.$snotify.warning('Company "' + this.company.company_name + '" has been deleted.');  
                  this.$tabs.close('/company/record');
              });
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });

    },
    /**
     * Modals ----------------------------------------------------------
     */
    add_reg_number_modal() {
      this.$store.commit('SHOW_ADD_REG_MODAL', {
        company_id: this.company.id,
        company_name: this.company.company_name
      })
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_reg_number_modal'));
    },
    edit_reg_number_modal() {
      this.$store.commit('SHOW_EDIT_REG_MODAL', {
        company_id: this.company.id,
        company_name: this.company.company_name,
        ltd_reg_number: this.company.rel_profile.ltd_reg_number
      })
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'edit_reg_number_modal'));
    },
    add_note_modal() {
      this.$store.commit('SHOW_ADD_NOTE_MODAL', {
        id: this.company.id,
        name: this.company.company_name,
        type: 'company',
        contacts: this.contacts
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_note_modal'));

    },
    add_files_modal() {
      this.$store.commit('SHOW_ADD_FILE_MODAL', {
        id: this.company.id,
        name: this.company.company_name,
        // employment_type: this.worker.rel_company_info.employment_type,
        type: 'company',
        // vat_registered: this.worker.rel_company_info.vat_registered,
        uploaded_files: this.files_uploaded,
        // nationality: this.worker.person.nationality,
      });
      this.$store.state.files.add_modal = true;
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'upload_file_modal'));
    },
    add_contact_modal() {
      this.$store.commit('SHOW_ADD_CONTACT_MODAL', {
        company_id: this.company.id,
        company_name: this.company.company_name
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_contact_modal'));
    },
    add_address_modal() {
      this.$store.commit('SHOW_ADD_ADDRESS_MODAL', {
        id: this.company.id,
        company_id: this.company.id,
        company_name: this.company.company_name
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_address_modal'));
    }
  },
  beforeDestroy() {
    this.loading_company = false;
    this.company = {};

    this.addresses_loaded = false;
    this.addresses = [];
    this.emails_loaded = false;
    this.emails = [];
    this.phones_loaded = false;
    this.phones = [];
    this.banks_loaded = false;
    this.banks = [];
    this.credit_finance_loaded = false;
    this.credit_finance = [];
    this.payment_process_info_loaded = false;
    this.payment_process_info = [];
    this.referral_rebate_loaded = false;
    this.referral_rebate = [];
    this.relationship_loaded = false;
    this.relationship = [];
    this.services_loaded = false;
    this.services = [];
    this.contracts_loaded = false;
    this.contracts = [];
    this.health_check_loaded = false;
    this.health_check = [];
    this.sent_health_check_loaded = false;
    this.sent_health_check = [];

    this.contacts_loaded = false;
    this.contacts = [];

    this.notes_loaded = false;
    this.notes = [];
    this.activity_loaded = false;
    this.activity = [];
  }
}
</script>

<style lang="scss">
.tab_unavailable {
  color: $red !important;

  &::before {
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    content:     "\f071   ";
  }
}

.edit_reg_no_btn {
  font-size:      0.85rem;
  color:          $blue;
  vertical-align: middle;

  &.focus, &:focus, &:hover, &.active, &:active, &.active.focus, &.active:focus,
  &.active:hover, &:active.focus, &:active:focus, &:active:hover {
    cursor: pointer;
  }
}

.company_barometer {
  display:        inline-block;
  vertical-align: top;
  width:          calc(100% - 160px);
}

#payroll_recruitment_client {
  display:        inline-block;
  vertical-align: top;
  width:          150px;
  background:     darken(#e3e53a, 7.5%);
  color:          $white;
  border-radius:  $border_radius;
  height:         40px;
  text-align:     center;
  padding:        5px;
  font-weight:    bold;
  line-height:    30px;
  font-size:      1rem;
}
</style>
